import React from 'react'
import styled from 'styled-components'
import IconEmpty from 'components/Icons/IconEmpty.png'
import { useTranslation } from 'react-i18next'

interface EmptyItemProps {
  keyword?: string
  visible?: boolean
}

const EmptyItem: React.FC<EmptyItemProps> = (props) => {
  const { keyword, visible } = props
  const { t } = useTranslation()

  if (!visible) return <></>

  return (
    <StyledEmptyItem>
      <img className="empty_image" src={IconEmpty} alt="empty" />
      <div>{t('search_keyword', { keyword })}</div>
    </StyledEmptyItem>
  )
}

const StyledEmptyItem = styled.div`
  min-height: 250px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .empty_image {
    width: 100px !important;
    height: 100px !important;
  }import { useTranslation } from 'react-i18next';

`
export default EmptyItem
